/**
 * Fetch All Enhancement Bundles API
 * Feature: 023-flexible-training-product
 */

import axiosInstance from '../../axiosInstance';
import { FetchEnhancementBundlesResponse } from '../types';

export const fetchAllEnhancementBundles = async (): Promise<FetchEnhancementBundlesResponse> => {
  const response = await axiosInstance.get<FetchEnhancementBundlesResponse>(
    '/api/enhancement-bundles'
  );

  return response.data;
};
